import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
} from "@mui/material";
import AppTextInput from "components/AppTextInput";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSettingsRequestAction,
  updateNumberlandLimitRequestAction,
} from "redux/actions/GeneralActions";
import CheckIcon from "@mui/icons-material/Check";

const Settings = () => {
  const dispatch = useDispatch();

  const { mailServices, settings } = useSelector((state) => state.general);
  const initialService = useMemo(
    () => settings?.ELITO_MAILER ?? "",
    [settings]
  );
  const initialNumberlandLimit = useMemo(
    () => settings?.numberland_number_limit ?? "",
    [settings]
  );

  const [service, setService] = useState(initialService);
  const [numberlandLimit, setNumberlandLimit] = useState(
    initialNumberlandLimit
  );

  useEffect(() => {
    // dispatch(getMailServicesRequestAction());
    dispatch(getSettingsRequestAction());
  }, []);

  useEffect(() => {
    setService(initialService);
    setNumberlandLimit(initialNumberlandLimit);
  }, [initialService, initialNumberlandLimit]);

  return (
    <Card>
      <CardHeader title="Settings" />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item>
            <AppTextInput
              label={"Numberland Number Limit"}
              value={numberlandLimit}
              schema={{ label: "label", value: "value" }}
              onChange={(e) => setNumberlandLimit(e.target.value)}
              endAdornment={
                <IconButton
                  onClick={() =>
                    dispatch(
                      updateNumberlandLimitRequestAction({
                        value: numberlandLimit,
                      })
                    )
                  }
                >
                  <CheckIcon />
                </IconButton>
              }
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Settings;
